module.exports = __webpack_public_path__ + "static/media/edit.0b9a4d95.svg";